import React from "react";
import PropTypes from "prop-types";

export default function Location({ address, city, onChange }) {
  return (
    <div className="location">
      <span className="location-address">*Plats</span>
      <div className="address">
        <input name="address" type="text" value={address} onChange={onChange} />
      </div>
      <span className="location-city">*Stad</span>
      <div className="city">
        <input name="city" type="text" value={city} onChange={onChange} />
      </div>
    </div>
  );
}

Location.propTypes = {
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
